import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'react-hot-toast'
import App from './App'
import './index.css'
import { initTheme } from './utils/theme'

// Initialiser le thème avant de rendre l'application
initTheme();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename="/">
        <App />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#23262F',
              color: '#F3F4F6',
              border: '1px solid #FACC15'
            },
            success: {
              iconTheme: {
                primary: '#FACC15',
                secondary: '#0F1419'
              }
            }
          }}
        />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
)
